import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'
import { pxToRem } from '#commerce/utils/pxToRem'

export default {
  brandStyles: {
    containerFullHeight: (height) => ({
      h: {
        sm: `calc(100svh - ${pxToRem(height)})`
      }
    })
  },
  classControls: 'mx-4 rounded-full bg-white p-2 shadow-sm',
  spacing: {
    none: 0,
    xsmall: 0.0625,
    small: 0.125,
    medium: 0.25,
    large: 0.50,
    xlarge: 1
  },
  titlePadding: 'mx-4',
  VfCanvasLinkedCardCollection: {
    carouselClasses: ''
  },
  VfCanvasCategoryCardCollection: {
    itemsProp: 'categoryCards',
    titleStyleClasses: 'mb-4 ~md:mb-6',
  },
  VfCanvasCTAButtonCollection: {
    itemClass: 'full',
    titleStyleClasses: 'mb-4 md:mb-6'
  },
  VfCanvasMultilinkCollection: {
    titleStyleClasses: 'mb-4'
  }
} satisfies RecursivePartial<CMSConfig['collection']>
